import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { Fonts } from '~/assets/style/fonts'
import Button from '~/components/Button'
import { Flyout } from '~/components/Flyout'
import { WithClassName } from '~/types/utils'

const Bloc = styled.div`
  padding-bottom: 20px;
  p { 
    ${Fonts.P2}
  }
  h2 {
    ${Fonts.H2}
    font-weight: 500;
    padding-bottom: 6px;
  }
`
type PureMarketplaceHelpFlyoutProps = WithClassName & {
  requestSentAt?: string
  onContact: () => void
}
const UnstyledPureMarketplaceHelpFlyout: FunctionComponent<PureMarketplaceHelpFlyoutProps> = ({ requestSentAt, onContact }) => {
  return (
    <Flyout.Content>
      <Flyout.Title>Marketplace introduction</Flyout.Title>
      <Flyout.Body>
        <Bloc>
          <h2>What is Pubstack Marketplace?</h2>
          <p>
            Pubstack Marketplace is a header bidding platform designed to maximize programmatic revenue for publishers by simplifying access to a global network of premium bidders through a single,
            easy-to-manage contract. This solution offers seamless integration, enhancing ad operations and revenue potential without the complexities of multiple agreements and technical setups
          </p>
        </Bloc>
        <Bloc>
          <h2>How much does it cost?</h2>
          <p>Pubstack Marketplace operates on a revenue-share model with no additional fees</p>
        </Bloc>
        <Bloc>
          <h2>How can I get started?</h2>
          <p>
            In order to activate Pubstack Marketplace for your inventory, you can reach out to your customer success manager or click on the “Contact me” button to receive further details from our
            team
          </p>
        </Bloc>
      </Flyout.Body>
      <Flyout.Actions>
        {!requestSentAt ? (
          <Button
            variant={'secondary'}
            onClick={() => {
              onContact()
            }}
            trackingLabel={'marketplace-teaser-request'}
          >
            Contact me
          </Button>
        ) : (
          <span>Last request sent {requestSentAt}</span>
        )}
      </Flyout.Actions>
    </Flyout.Content>
  )
}

export const PureMarketplaceHelpFlyout = styled(UnstyledPureMarketplaceHelpFlyout)``
